import { useRouter } from 'next/router'
import classnames from 'classnames/bind'
import Link from 'components/shared/Link'
import { Label, Text, Title } from 'components/typo'
import React from 'react'
import { useTranslate } from 'react-polyglot'
import { SINGLES } from 'services/constants'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const ArticleCardContent = ({
  className,
  featured,
  tiny,
  href,
  duo,
  author,
  title,
  description,
  category,
  timeToRead,
  publishedAt,
  postSubCategory,
  level,
}) => {
  const router = useRouter()
  const t = useTranslate()
  const formattedTimeToRead = timeToRead
    ? `${t('blog.read_time_short', { value: timeToRead })}`
    : null

  const publishDate = publishedAt
    ? new Intl.DateTimeFormat('en', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      }).format(new Date(publishedAt))
    : null

  return (
    <div
      className={cx(className, css.ArticleCardContent, {
        featured,
        tiny,
        duo,
        regular: !featured,
      })}
    >
      <div className={css.content}>
        <div className={css.category}>
          {router.query.slug && router.query.category ? (
            <Link
              className={cx(css.categoryLink, {
                withTimeToRead: formattedTimeToRead,
              })}
              href={`${SINGLES.blog.url}/categories/${router.query?.category}/${postSubCategory?.slug}`}
            >
              <Label className={css.categoryLabel}>
                {postSubCategory?.name}
              </Label>
            </Link>
          ) : (
            <>
              {category && category.name && category.slug && (
                <Link
                  className={cx(css.categoryLink, {
                    withTimeToRead: formattedTimeToRead,
                  })}
                  href={`${SINGLES.blog.url}/categories/${category.slug}`}
                >
                  <Label className={css.categoryLabel}>{category.name}</Label>
                </Link>
              )}
            </>
          )}
          {level && <Label className={css.level}>{level}</Label>}
          {formattedTimeToRead && (
            <Label className={css.timeToRead}>{formattedTimeToRead}</Label>
          )}
        </div>
        {title && (
          <Link className={css.titleLink} href={href}>
            <Title className={css.title} size={featured && 'big'}>
              {title}
            </Title>
          </Link>
        )}
        {description && (
          <Text
            theme="chambray"
            className={css.text}
            size={!featured && 'small'}
          >
            {description}
          </Text>
        )}
        {author?.slug && (
          <Link href={`/user/${author?.slug}`} className={css.label}>
            <Label className={css.label}>
              <span className={css.author}>
                {author?.name || author?.username}
              </span>
              {publishDate && publishDate}
            </Label>
          </Link>
        )}
      </div>
    </div>
  )
}

ArticleCardContent.defaultProps = {}

export default ArticleCardContent
